import { CrossIcon } from './CrossIcon';

/**
 * author: Nick
 * id 5644CD16-FA4D-4F68-8DAC-996169C778E1
 * name cross
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cross.svg
 * tags
 * - Religion 
 * - Holiday 
 */
export const ReligionChristianIcon = CrossIcon;
export default ReligionChristianIcon